module.exports = __webpack_public_path__ + "img/webinar.a22eeea9.png";